<template>
  <client-only>
    <v-skeleton-loader v-if="props.isUserInfoSkeletonShown" v-bind="skeletonProps" />
    <p v-else class="wd-font-medium wd-text-otempmd" :class="isFunBookV2 ? '!wd-mb-0' : props.class">
      {{ nickname }}
    </p>

    <template #fallback>
      <v-skeleton-loader v-bind="skeletonProps" />
    </template>
  </client-only>
</template>

<script lang="ts" setup>
import { usePlatformStore } from '@/store-pinia/platform'

interface Props {
  isUserInfoSkeletonShown: boolean
  class?: ClassType
}

const props = defineProps<Props>()

const { $store } = useNuxtApp()
const platformStore = usePlatformStore()
const { isFunBookV2 } = storeToRefs(platformStore)

const user = computed(() => $store.getters['authentication/getUser'] || {})
const nickname = computed(() => user.value.nickname)
const skeletonProps = computed(() => ({ class: `wd-rounded wd-h-6 wd-w-24 ${props.class}`, type: 'ossein' }))
</script>
